const LOCAL_HOSTS = ["localhost", "127.0.0.1"];

export default function apiBaseUrl() {
  const hostname = window.location.hostname.trim();
  const configuredUrl =
    hostname === "181.57.163.54"
      ? process.env.VUE_APP_API_URL_SECOND
      : process.env.VUE_APP_API_URL;

  if (configuredUrl) {
    return configuredUrl.replace(/\/$/, "");
  }

  if (!LOCAL_HOSTS.includes(hostname)) {
    return `${window.location.origin}/hemolife-back`;
  }

  return "";
}
